// Wait For Element Function
function waitForElement(selector, trigger, delayInterval, delayTimeout) {
    var interval = setInterval(function () {
        if (document && document.querySelector(selector) && document.querySelectorAll(selector).length > 0) {
            clearInterval(interval);
            trigger();
        }
    }, delayInterval);
    setTimeout(function () {
        clearInterval(interval);
    }, delayTimeout);
}

$(document).ready(function() {

    // =========== Announcement Bar Slider Start ==============================

    if($(".js-cwr-announcement-slider").length > 0) {
        $('.js-cwr-announcement-slider').slick({
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: false,
            swipe: false,
            slidesToShow: 1,
            pauseOnFocus: false,
            pauseOnHover: false,
        });
    }

    // =========== Announcement Bar Slider End ==============================


    // =========== Product Benefits Slider Start ==============================

    if($(".js-cwr-product-benefits-slider").length > 0) {
        $('.js-cwr-product-benefits-slider').slick({
            autoplay: true,
            autoplaySpeed: 0,
            speed: 5000,
            arrows: false,
            swipe: false,
            slidesToShow: 1,
            variableWidth: true,
            cssEase: 'linear',
            pauseOnFocus: false,
            pauseOnHover: false,
        });
    }

    // =========== Product Benefits Slider End ==============================


    // =========== Check List Slider Start ==============================

    if($(".js-cwr-check-list-slider").length > 0) {
        $('.js-cwr-check-list-slider').slick({
            autoplay: true,
            autoplaySpeed: 0,
            speed: 5000,
            arrows: false,
            swipe: false,
            slidesToShow: 1,
            variableWidth: true,
            cssEase: 'linear',
            pauseOnFocus: false,
            pauseOnHover: false,
        });
    }

    // =========== Check List Slider End ==============================


    // =========== Collections Tab Start ==============================

    if($(".js-cwr-collections-tab-nav-item").length > 0) {
        $('.js-cwr-collections-tab-nav-item').click( function() {
            var tabID = $(this).attr('data-tab');
            $(this).addClass('active').siblings().removeClass('active');
            $('#tab-'+tabID).addClass('active').siblings().removeClass('active');
        });
    }

    // =========== Collections Tab End ==============================


    // ========================== Instagram slider start =================================================

    if($(".js-cwr-instagram-slider").length > 0) {
        $('.js-cwr-instagram-slider').slick({
            // autoplay: true,
            // autoplaySpeed: 2000,
            arrows: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '5.933vw',
            lazyLoad: 'progressive',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: '25vw'
                    }
                }
            ]
        });
    }

    // ========================== Instagram slider end =================================================

    
    // ========================== Faq accordian start =================================================
 
	if($('.js-cwr-accordian').length > 0) {
        var faqAccordion = new Accordion({
            element: ".js-cwr-accordian",
            activeTab: 1
        });
    }

    // ========================== Faq accordian end =================================================


    // ========================== Product Details accordian start =================================================
 
	if($('.js-cwr-accordian-product-details').length > 0) {
        var productDetailsAccordion = new Accordion({
            element: ".js-cwr-accordian-product-details"
        })
    }

    // ========================== Product Details accordian end =================================================

    
    // ========================== Collections Filter accordian start =================================================
	if($('.js-cwr-filter-accordian').length > 0) {
        var collectionsFilterAccordion = new Accordion({
            element: ".js-cwr-filter-accordian"
        })
    }
    // ========================== Collections Filter accordian end =================================================


    /* ===================== mobile-menu start ================================ */

    $(function () {
        const body = $('body');
        const mobileMenu = $('.mobile-menu');
        const mobileMenuBody = mobileMenu.children('.mobile-menu__body');

        if (mobileMenu.length) {
            const open = function() {
                const bodyWidth = body.width();
                body.css('overflow', 'hidden');
                body.css('paddingRight', (body.width() - bodyWidth) + 'px');

                mobileMenu.addClass('mobile-menu--open');
            };
            const close = function() {
                body.css('overflow', 'auto');
                body.css('paddingRight', '');

                mobileMenu.removeClass('mobile-menu--open');
            };

            $('.js-menu-toggle-btn').on('click', function() {
                open();
            });
            $('.mobile-menu__backdrop, .mobile-menu__close').on('click', function() {
                close();
            });
        }

        const panelsStack = [];
        let currentPanel = mobileMenuBody.children('.mobile-menu__panel');

        mobileMenu.on('click', '[data-mobile-menu-trigger]', function(event) {
            const trigger = $(this);
            const item = trigger.closest('[data-mobile-menu-item]');
            let panel = item.data('panel');

            if (!panel) {
                panel = item.children('[data-mobile-menu-panel]').children('.mobile-menu__panel');

                if (panel.length) {
                    mobileMenuBody.append(panel);
                    item.data('panel', panel);
                    panel.width(); // force reflow
                }
            }

            if (panel && panel.length) {
                event.preventDefault();

                panelsStack.push(currentPanel);
                currentPanel.addClass('mobile-menu__panel--hide');

                panel.removeClass('mobile-menu__panel--hidden');
                currentPanel = panel;
            }
        });
        mobileMenu.on('click', '.mobile-menu__panel-back', function() {
            currentPanel.addClass('mobile-menu__panel--hidden');
            currentPanel = panelsStack.pop();
            currentPanel.removeClass('mobile-menu__panel--hide');
        });
    });

    /* ===================== mobile-menu end ================================ */



    /* ===================== Quantity Add Remove Start ================================ */

    if($('.js-cwr-quantity-btn-add').length > 0) {
        $('.js-cwr-quantity-btn-add').click(function () {
            var max = parseInt($(this).closest('.cwr-quantity').find('.cwr-quantity__input').attr('max'));
            // console.log("datamax1: " + max1);
            if ($(this).prev().val() < max) {
                $(this).prev().val(+$(this).prev().val() + 1);
            }
        }); 
    }
    
    if($('.js-cwr-quantity-btn-sub').length > 0) {
        $('.js-cwr-quantity-btn-sub').click(function () {
            if ($(this).next().val() > 1) {
                if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
            }
        });
    }

    /* ===================== Quantity Add Remove End ================================ */


    /* ===================== Product details slider Start ================================ */
    if($('.js-cwr-product-details-main-slider').length > 0 && $('.js-cwr-product-details-nav-slider').length > 0) {
        $('.js-cwr-product-details-main-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.js-cwr-product-details-nav-slider'
        });

        $('.js-cwr-product-details-nav-slider').slick({
            slidesToShow: 8,
            slidesToScroll: 1,
            vertical: true,
            asNavFor: '.js-cwr-product-details-main-slider',
            focusOnSelect: true,
            lazyLoad: 'progressive',
            arrows: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 6
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        vertical: false,
                        slidesToShow: 6
                    }
                }
            ]
        });
    }
    /* ===================== Product details slider End ================================ */


    // ========================== Related Product slider start =================================================
    

    function initializeRelatedProductSlider() {
        
        $('.js-cwr-related-product-slider').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 4L6 8L10 12" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            lazyLoad: 'progressive',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: "unslick"
                }
            ]
        });    
    }
        
    // product-recommendations start
    waitForElement(".js-cwr-related-product-slider .js-cwr-related-product-slide", initializeRelatedProductSlider, 50, 15000);
    // product-recommendations end

    $(window).on('resize', function(){
        if ($(window).width() < 768) {
            if($(".js-cwr-related-product-slider").hasClass("slick-initialized")) {
                $('.js-cwr-related-product-slider').slick('unslick');
                
            }
        }
        else {
            if($(".js-cwr-related-product-slider").hasClass("slick-initialized") === false) {
                initializeRelatedProductSlider();
            }
        }
    });

    // ========================== Related Product slider end =================================================


    // ========================== Related Product slider start =================================================
    if($(".js-cwr-related-product-cart-slider").length > 0) {
        $('.js-cwr-related-product-cart-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 4L6 8L10 12" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            lazyLoad: 'progressive',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    }    
    // ========================== Related Product slider end =================================================


    // ========================== Related Product slider start =================================================
    if($(".js-cwr-related-product-side-cart-slider").length > 0) {
        $('.js-cwr-related-product-side-cart-slider').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 4L6 8L10 12" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            lazyLoad: 'progressive'
        });
    }    
    // ========================== Related Product slider end =================================================


    // ========================== Collections filter toggle start =================================================
    if($(".js-cwr-all-collections-filter-btn").length > 0) {
        $(".js-cwr-all-collections-filter-btn").click(function(e){
            e.preventDefault();
            $(".js-cwr-all-collections-filter-box").toggle('slow');
        });
    }
    // ========================== Collections filter toggle end =================================================


    // ======================= Cart Sidebar Start ===============================================================

    if($('.js-side-cart-open-btn').length > 0) {
        
        $(".js-side-cart-open-btn").click(function(event){
            event.preventDefault();
            $(".js-cwr-side-cart").addClass('is-active');
            $("body").addClass('is-active-cart');
        });

    }

    if($('.js-cwr-side-cart-close-btn').length > 0) {
        $('body').on('click','.js-cwr-side-cart-close-btn', function(event){
            // $(".js-cwr-side-cart-close-btn").click(function(event){
            event.preventDefault();
            $(".js-cwr-side-cart").removeClass('is-active');
            $("body").removeClass('is-active-cart');
        });
    }

    if($('.js-cwr-side-cart-overlay').length > 0) {
        $('body').on('click','.js-cwr-side-cart-overlay', function(event){
        // $(".js-cwr-side-cart-overlay").click(function(event){
            event.preventDefault();
            $(".js-cwr-side-cart").removeClass('is-active');
            $("body").removeClass('is-active-cart');
        });
    }

    // ================================= Cart Sidebar End =====================================================


    // ======================= Price range slider Start ===============================================================
    if($('#slider-range').length > 0) {
        $( "#slider-range" ).slider({
            range: true,
            min: 0.00,
            max: 1100,
            values: [ 0, 1100 ],
            slide: function( event, ui ) {
                $( "#amount" ).val( "$" + ui.values[ 0 ] + " - $" + ui.values[ 1 ] );
            }
        });
        $( "#amount" ).val( "$" + $( "#slider-range" ).slider( "values", 0 ) +
          " - $" + $( "#slider-range" ).slider( "values", 1 ) );
    }
    // ======================= Price range slider End ===============================================================


    // ======================= Phone number input validation Start ===============================================================
    if($('.js-phone-number-input').length > 0) {
        $('body').on('keyup', '.js-phone-number-input', function () {
            var $input = $(this),
                value = $input.val(),
                length = value.length,
                inputCharacter = parseInt(value.slice(-1));
        
            if (!((length > 0 && inputCharacter >= 0 && inputCharacter <= 10) || (length === 1 && inputCharacter >= 7 && inputCharacter <= 10))) {
                $input.val(value.substring(0, length - 1));
            }
        });
    }
    // ======================= Phone number input validation End ===============================================================


});

